const campaignJsText50 = {};

campaignJsText50.init = () => {
  console.log('sample');
  const jsCampaignSub = document.getElementsByClassName('js-campaign-sub');

  $(jsCampaignSub).txtTruncate({
    end: '',
    lines: 6,
    multiline: true
  });
};


document.addEventListener('DOMContentLoaded', () => {
  campaignJsText50.init();
});



// WEBPACK FOOTER //
// ./scripts/components/campaign-text-50.js